// extracted by mini-css-extract-plugin
module.exports = {"marginlefting":"home_marginlefting_1GtH6"};